import { takeLatest } from 'redux-saga/effects';
import { call, put } from 'redux-saga/effects';
import { isSp } from 'shared/utils/isSp';

import Api from '../api';
import notification from '../utils/notifications';
import { ActionTypes } from 'shared/constants';

function* fetchHighlightsSaga() {
  yield put({
    type: ActionTypes.FETCH_HIGHLIGHTS_STARTED
  });

  try {
    const { response, request } = yield call(Api.Projects.fetchHighlights);

    if (request.status && (request.status === 200 || request.status === 204)) {
      yield put({
        type: ActionTypes.FETCH_HIGHLIGHTS_SUCCESS,
        payload: {
          highlights: response
        }
      });
    } else {
      const isSpCheck = yield call(isSp);
      const notificationClass = isSpCheck
        ? ''
        : 'ant-notification-success ant-notification-notice-description';
      yield call(notification, { type: 'error', data: response, className: notificationClass });
    }
  } catch ({ message }) {
    yield put({
      type: ActionTypes.FETCH_HIGHLIGHTS_FAILURE
    });
  }
}

export default function* watchHighlights() {
  yield takeLatest(ActionTypes.FETCH_HIGHLIGHTS, fetchHighlightsSaga);
}
